(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('loadingPanel', loadingPanelFactory);

    loadingPanelFactory.$inject = ['$$rAF'];
    function loadingPanelFactory(requestAnimationFrame) {
        return function loadingPanel(container, toggle) {
            var panel, panelParent, doc;
            container = angular.element(container);
            doc = container.prop('ownerDocument') || document,
            panel = container.data('panel');

            if (!panel && toggle) {
                panelParent = !isBodyAncestor() ? container : angular.element(doc.body);
                panelParent.prepend(panel = angular.element('<div />').addClass('loading-panel'));
                container.data('panel', panel);
                requestAnimationFrame(callback);
            }
            else if (panel && !toggle) {
                panel.remove();
                container.removeData('panel');
            }

            function callback() {
                var rect;
                if (panel.parent().length) {
                    rect = container.clientRect();
                    panel.css({ top: rect.top + 'px', left: rect.left + 'px', width: rect.width + 'px', height: rect.height + 'px' });
                    requestAnimationFrame(callback);
                }
            }

            function isBodyAncestor() {
                var x = container[0];
                return x.window === x || x === doc || x === doc.documentElement;
            }
        }
    }
})();